<template>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/supplier' }">服务商列表</el-breadcrumb-item>
            <el-breadcrumb-item>添加服务商</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <div style="width:80%">
        <el-form :model="form" label-width="180px">
          <el-form-item label="万里牛账号">
            <el-select filterable v-model="form.wlnid" placeholder="请选择合适的服务商" size="large">
              <el-option
                v-for="item in baseData.wlnlist"
                :key="item.supplier_uid"
                :label="item.supplier_name"
                :value="item.supplier_uid"
              />
            </el-select>
            <el-button style="margin-left:20px" type="primary" @click="getWlnList">刷新服务商列表</el-button>
          </el-form-item>
          <el-form-item label="快递公司账号">
            <el-select filterable v-model="form.companyid" placeholder="请选择合适的快递公司账号" size="large">
              <el-option
                v-for="item in baseData.wlncompanylist"
                :key="item.distr_code"
                :label="item.distr_name"
                :value="item.distr_code"
              />
            </el-select>
            <el-button style="margin-left:20px" type="primary" @click="getCompanyList">刷新快递公司列表</el-button>
          </el-form-item>
          <el-form-item label="万里牛商铺">
            <el-select filterable v-model="form.wlnshopname" placeholder="请选择合适的商铺" size="large">
              <el-option
                v-for="item in baseData.wlnshoplist"
                :key="item.shop_name"
                :label="item.shop_name"
                :value="item.shop_name"
              />
            </el-select>
            <el-button style="margin-left:20px" type="primary" @click="getWlnShopList">刷新商铺列表</el-button>
          </el-form-item>
          <el-form-item label="T+往来单位编号">
            <el-input v-model="form.TjiaCode" maxlength="150" show-word-limit/>
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input v-model="form.company" maxlength="150" show-word-limit/>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="form.password" placeholder="无需更改，请勿填写" maxlength="100"/>
          </el-form-item>
          <el-form-item label="重复密码">
            <el-input v-model="form.repassword" placeholder="无需更改，请勿填写" maxlength="100"/>
          </el-form-item>
          <el-form-item label="联系人">
            <el-input v-model="form.name" maxlength="150" show-word-limit/>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.mobile" maxlength="20" show-word-limit/>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="form.email" maxlength="150" show-word-limit/>
          </el-form-item>
          <el-form-item label="纳税人识别号">
            <el-input v-model="form.TIN" maxlength="100" show-word-limit/>
          </el-form-item>
          <el-form-item label="公司所在地">
            <el-input v-model="form.address" maxlength="250" show-word-limit/>
          </el-form-item>
          <el-form-item label="银行账户">
            <el-input v-model="form.bankAccount" maxlength="250" show-word-limit/>
          </el-form-item>
          <el-form-item label="开户行">
            <el-input v-model="form.bank" maxlength="250" show-word-limit/>
          </el-form-item>
          <el-form-item label="地区">
            <el-cascader v-model="form.areas" filterable :options="baseData.citydata" :props="props" @change="changeAreas"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button @click="goBack">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import api from '@/api/index'
  import citydata from '@/assets/js/citydata'
  import { ElMessage, ElLoading } from 'element-plus'
  import {useRouter} from 'vue-router'

  const router = useRouter()
  const baseData:any = reactive({
    citydata : [],
    wlnlist : [],
    wlncompanylist : [],
    wlnshoplist : [],
  })
  const props = {
    expandTrigger: 'hover',
    children: 'cityArr',
    label: 'Name',
    value: 'Code',
  }
  const form = reactive({
    wlnid:'',
    companyid:'',
    wlnshopname:'',
    TjiaCode:'',
    company: '',
    password: '',
    repassword: '',
    name: '',
    mobile: '',
    email: '',
    TIN: '',
    address: '',
    bankAccount: '',
    bank: '',
    areas: [],
    province: '',
    city: '',
    area: '',
  })
  const changeAreas = () => {
    form.province = form.areas[0]
    form.city = form.areas[1]
    form.area = form.areas[2]
  }
  const onSubmit = () => {
    const loading = ElLoading.service({lock: true})
    if(!form.wlnid){
      ElMessage.error('请选择合适的服务商')
      loading.close()
      return false
    }
    if(!form.wlnshopname){
      ElMessage.error('请选择合适的商铺')
      loading.close()
      return false
    }
    api.supplierApi.save(form).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/supplier");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const goBack = () => {
    router.go(-1);
  }
  const getWlnList = () => {
    const loading = ElLoading.service({lock: true})
    api.supplierApi.getWlnList({}).then((res:any)=>{
      if(res.code==200){
        baseData.wlnlist = res.data
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const getWlnShopList = () => {
    const loading = ElLoading.service({lock: true})
    api.supplierApi.getWlnShopList({}).then((res:any)=>{
      if(res.code==200){
        baseData.wlnshoplist = res.data.data
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const getCompanyList = () => {
    const loading = ElLoading.service({lock: true})
    api.supplierApi.getCompanyList({}).then((res:any)=>{
      if(res.code==200){
        baseData.wlncompanylist = res.data
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  onMounted(() => {
    baseData.citydata = citydata.provinceArr
    getWlnList()
    getWlnShopList()
    getCompanyList()
  })
  </script>
